import { UpdateStatus } from "aint-types";
import dayjs from "dayjs";
export const COLORS_BY_UPDATE_STATUS: Record<
  UpdateStatus,
  { background: string; border: string }
> = {
  overdue: {
    background: "#CD0A0E0D",
    border: "0.5px solid #CD0A0EBA !important",
  },
  pending: {
    background: "#FAB6000D",
    border: "0.5px solid #C57D00 !important",
  },
  completed: {
    background: "#00C85320",
    border: "0.5px solid #087C4C !important",
  },
  ended: {
    background: "#00C85320",
    border: "0.5px solid #087C4C !important",
  },
};

export function getImpactFieldColors(
  year: string,
  month: number,
  value: string,
  startDate: string,
  confirmationType?: UpdateStatus
): { border: string; background: string } | undefined {
  const startDayJs = dayjs(startDate)
    .set("second", 0)
    .set("minute", 0)
    .set("hour", 0);
  const currentYear = dayjs().year();
  const isPastYear = currentYear > Number.parseInt(year);
  const isCurrentYear = currentYear.toString() === year;
  const currentMonth = dayjs().month();
  const monthDifference = month - currentMonth;
  const emptyValue = !value || value.length === 0;

  let updateStatus: UpdateStatus | undefined;

  const fieldDate = dayjs(`${year}-${month + 1}-1`);
  if (fieldDate.isBefore(startDayJs)) {
    return;
  }

  if ((isPastYear || (isCurrentYear && monthDifference < 0)) && emptyValue) {
    updateStatus = "overdue";
  }
  if (isCurrentYear && monthDifference === -1 && emptyValue) {
    updateStatus = "pending";
  } else if (
    (isPastYear || (isCurrentYear && monthDifference <= -1)) &&
    !emptyValue
  ) {
    if (!confirmationType) {
      updateStatus = monthDifference < -1 ? "overdue" : "pending";
    } else {
      updateStatus = "completed";
    }
  }

  if (updateStatus === "completed" && confirmationType !== "completed") {
    updateStatus = confirmationType;
  }

  return updateStatus ? COLORS_BY_UPDATE_STATUS[updateStatus] : undefined;
}
